interface PostParams {
	method: 'POST' | 'GET',
	uri: string,
	headers: { [key: string]: string },
	body: { [key: string]: string | number }
}

function didRequestTimedout(response: any) {
	const phpTimeout = didPHPTimedout(response);
	const bffTimeout = didBFFTimedout(response);
	return phpTimeout || bffTimeout;
}

function didPHPTimedout(response: any) {
	return response.error && response.errorCode === 28;
}

function didBFFTimedout(response: any) {
	return (
		response.errors &&
		response.errors[0] &&
		response.errors[0].extensions &&
		response.errors[0].extensions.exception &&
		response.errors[0].extensions.exception.type === "request-timeout"
	);
}

const Api = {
	post: async (
		url: string,
		params: any,
		retries?: number,
		headers: { [key: string]: string } = {}
	): Promise<any> => {
		const preDefinedHeaders = {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		  };
		  headers = Object.keys(params).length > 0 ? Object.assign(preDefinedHeaders, headers) : preDefinedHeaders;
		  params = Object.keys(params).length > 0 ? params : {};

		  if (typeof C !== "undefined" && C.global && C.global.csrfToken) {
			params.token = C.global.csrfToken;
		}

		  const options: PostParams = {
			method: 'POST',
			uri: url,
			headers: headers,
			body: params
		  };

		  return fetchRetry(options, retries);
	}
};

const fetchRetry = (options: PostParams, retryLimit: number = 1) => {
	return new Promise(async (resolve, reject) => {
		let res: any;
		for (let retryCount = 1; retryCount <= retryLimit; retryCount++) {
			try {
				options.body.bff_retry_count = retryCount;
				const body = JSON.stringify(options.body);
				let res = await fetch(options.uri, {
					credentials: 'include',
					method: options.method,
					headers: options.headers,
					body,
				});

				if (!res.ok) {
					throw `HTTP status: ${res.status} for ${options.uri}`;
				}

				const json = await res.json();
				if (didRequestTimedout(json)) {
					throw json;
				}
				resolve(json);
				break;
			} catch (e) {
				res = e;
			}
		}
		resolve(res);
	});
};

export default Api;
